import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

// 260922 대표 계정 실사고 — BE 액세스 토큰(security.yaml jwt.expireTime = 24시간)이 만료된 채 앱을 열면 스토어는 여전히
//   로그인 상태(userData 영속)라 홈(/intro)이 401 을 '현판 0·사업장 0' 으로 읽어 검은 데모 카드 + '사업장 등록하기' 를 그렸다.
//   아래 7일/20일 임계는 토큰이 그만큼 길던 시절 값이고, 갱신(renew/access-token)은 유효한 토큰이 있어야만 통과하는 경로라
//   만료 뒤엔 어차피 401 이다. 토큰 수명이 지났으면 20일 경로와 같이 세션을 정리하고 로그인으로 보낸다.
//   (게스트는 토큰이 없어 판정 불가 → 종전대로 통과. /intro 의 게스트 401 무시 정책(ServiceExec)은 그대로.)
//   판정은 기기 시계로만 한다(리뷰 260922): 토큰의 timestamp(발급, 서버 ms)·exp(초) 차가 수명이고, 로그인 순간 기기 시계(ttl) + 수명이
//   기기 기준 만료 시각이다. 서버 exp 를 기기 시계와 직접 비교하면 시계가 앞선 기기는 매번 로그인 직후 쫓겨난다.
const jwtClaims = token => {
  try {
    const raw = String(token || '').replace(/^Bearer\s+/i, '');
    const payload = raw.split('.')[1];
    if (!payload) return null;
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(escape(window.atob(b64))));
  } catch (_) {
    return null;
  }
};
export const isAccessTokenExpired = () => {
  const claims = jwtClaims(store.getters['user/getAccessToken']);
  const ttl = Number(store.getters['user/getTTL']);
  if (!claims || typeof claims.exp !== 'number' || typeof claims.timestamp !== 'number' || !(ttl > 0)) return false;
  const lifetime = claims.exp * 1000 - claims.timestamp;
  return lifetime > 0 && new Date().getTime() >= ttl + lifetime;
};
// 죽은 세션 정리. signOut 은 진행 중이면 재진입 가드로 아무것도 지우지 않고 돌아오는데(전역 401 핸들러가 먼저 불렀을 때),
//   그러면 userNo 가 남아 /signin beforeEnter 가 /intro 로 되돌리고 이 가드가 다시 /signin 으로 보내는 핑퐁이 된다(리뷰 260922).
//   로컬 상태는 여기서 반드시 비운다(storeLogout 은 멱등, 진행 중인 signOut 이 나머지 모듈 초기화를 마친다).
export const clearDeadSession = async () => {
  try { await store.dispatch('user/signOut'); } catch (_) { /* 로컬 정리는 아래에서 */ }
  if (!isEmpty(store.getters['user/getUserData']?.userNo)) store.commit('user/storeLogout');
};

export const tokenRenewCheck = async (to, next) => {
  if (to.path !== '/main' && to.path !== '/intro') return true; // 260909 /intro 가 메인 // 메인 페이지가 아닌 경우 토큰 체크를 하지 않음.
  if (isAccessTokenExpired()) {
    await clearDeadSession();
    next({ path: '/signin', replace: true });
    return false;
  }
  const ttl = store.getters['user/getTTL'];
  if (isEmpty(ttl)) return true;
  const currentDate = new Date().getTime();
  const sevenDaysInMillis = 7 * 24 * 60 * 60 * 1000;
  const endDaysInMillis = 20 * 24 * 60 * 60 * 1000;
  const ttlWithSevenDays = ttl + sevenDaysInMillis;
  const ttlWithEndDays = ttl + endDaysInMillis;

  if (currentDate >= ttlWithEndDays) {
    await store.dispatch('user/signOut');
    // 260521 호크룩스: history stack에 /signin push 방지 → replace
    next({ path: '/signin', replace: true });
    return false;
  }
  if (currentDate >= ttlWithSevenDays) {
    await store.dispatch('user/renewAccessToken');
  }
  return true;
};
